import { BottomSheet, BottomSheetIllustrationContent } from "@clipboard-health/ui-components";
import { type UseModalState } from "@clipboard-health/ui-components";
import { DialogContent } from "@mui/material";
import { useCallback } from "react";
import { generatePath, useHistory } from "react-router-dom";

import { BottomSheetHeader } from "../../components/BottomSheetHeader";
import { Button } from "../../components/Button";
import { DialogFooter } from "../../components/DialogFooter";

interface LicenseErrorBottomSheetProps {
  modalState: UseModalState;
  roleDetailsPath: string;
  qualificationId: string;
}

export function AddLicenseErrorBottomSheet(props: LicenseErrorBottomSheetProps) {
  const { modalState, roleDetailsPath, qualificationId } = props;
  const history = useHistory();

  const handleClose = useCallback(() => {
    modalState.closeModal();
  }, [modalState]);

  return (
    <BottomSheet
      footer={
        <DialogFooter orientation="vertical">
          <Button
            fullWidth
            size="large"
            onClick={() => {
              history.replace(generatePath(roleDetailsPath, { qualificationId }));
            }}
          >
            Try again
          </Button>
        </DialogFooter>
      }
      header={<BottomSheetHeader onClose={handleClose} />}
      modalState={modalState}
    >
      <DialogContent sx={{ paddingX: 5 }}>
        <BottomSheetIllustrationContent
          illustrationType="document-rejected"
          title="Something went wrong"
          description="An issue occurred while adding your license. Please try again or wait a few minutes and try again later."
        />
      </DialogContent>
    </BottomSheet>
  );
}
